/**
 * Diamond Mystery Box Grid - JavaScript
 * Handles modal interactions and box content display
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const sections = document.querySelectorAll('[data-section-id]');

    sections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      if (!sectionId) return;

      // Parse data
      const dataEl = section.querySelector('[data-diamond-box-data]');
      if (!dataEl) {
        console.warn('[Diamond Box] No data element found in section');
        return;
      }

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (error) {
        console.error('[Diamond Box] Failed to parse data:', error);
        return;
      }

      // Initialize modal handlers
      initModalHandlers(section, data);

      // Initialize card click handlers
      initCardHandlers(section);
    });
  }

  function initCardHandlers(section) {
    const cards = section.querySelectorAll('.diamond-box-card');

    cards.forEach(card => {
      const button = card.querySelector('[data-box-action="view-contents"]');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const boxNumber = button.dataset.boxNumber;
          openModal(boxNumber);
        });
      }

      // Also make the whole card clickable if it has contents
      if (button) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', (e) => {
          // Don't trigger if clicking the button directly (handled above)
          if (e.target === button || button.contains(e.target)) return;
          const boxNumber = card.dataset.boxNumber;
          openModal(boxNumber);
        });
      }
    });
  }

  function initModalHandlers(section, data) {
    const modal = document.getElementById('diamond-box-modal');
    if (!modal) return;

    // Close button
    const closeButtons = modal.querySelectorAll('[data-modal-close]');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', () => closeModal());
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal();
      }
    });

    // Store data globally for modal access
    window.DIAMOND_BOX_DATA = data;
  }

  function openModal(boxNumber) {
    const modal = document.getElementById('diamond-box-modal');
    if (!modal) {
      console.error('[Diamond Box] Modal element not found!');
      return;
    }

    const data = window.DIAMOND_BOX_DATA;
    if (!data || !data.boxes) {
      console.error('[Diamond Box] No data available!', data);
      return;
    }

    const boxProducts = data.boxes[boxNumber];

    if (!boxProducts || boxProducts.length === 0) {
      console.warn('[Diamond Box] No products found for box', boxNumber);
      return;
    }

    // Update modal title
    const titleEl = modal.querySelector('[data-modal-title]');
    if (titleEl) {
      titleEl.textContent = `Box (${boxNumber}) Combinations`;
    }

    // Update modal body
    const bodyEl = modal.querySelector('[data-modal-body]');
    if (bodyEl) {
      bodyEl.innerHTML = renderProducts(boxProducts);
    }

    // Show modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Analytics
    if (window.gtag) {
      gtag('event', 'view_diamond_box', {
        box_number: boxNumber,
        product_count: boxProducts.length
      });
    }
  }

  function closeModal() {
    const modal = document.getElementById('diamond-box-modal');
    if (!modal) return;

    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function renderProducts(products) {
    if (!products || products.length === 0) {
      return `
        <div class="diamond-modal-empty">
          <div class="diamond-modal-empty__icon">📦</div>
          <p class="diamond-modal-empty__text">No products in this box</p>
        </div>
      `;
    }

    let html = '<div class="diamond-modal-products">';

    products.forEach((product) => {
      const msrpPrice = product.msrpPriceFormatted || product.compareAtPriceFormatted || product.priceFormatted || '';

      html += `
        <div class="diamond-modal-product">
          ${product.image ? `
            <img
              src="${escapeHtml(product.image)}"
              srcset="${escapeHtml(product.imageHigh || product.image)} 2x"
              alt="${escapeHtml(product.title)}"
              class="diamond-modal-product__image"
              loading="lazy"
            >
          ` : `
            <div class="diamond-modal-product__image diamond-modal-product__image--placeholder">
              <span>?</span>
            </div>
          `}

          <div class="diamond-modal-product__info">
            <h4 class="diamond-modal-product__title">${escapeHtml(product.title)}</h4>

            ${product.sku ? `
              <div class="diamond-modal-product__sku">SKU: ${escapeHtml(product.sku)}</div>
            ` : ''}

            <div class="diamond-modal-product__price">
              ${escapeHtml(msrpPrice)}
            </div>

            ${product.authenticatedBy ? `
              <div class="diamond-modal-product__auth">
                <span>Authenticated by</span>
                <span class="diamond-modal-product__auth-badge">${escapeHtml(product.authenticatedBy)}</span>
              </div>
            ` : ''}

            ${product.url ? `
              <a href="${escapeHtml(product.url)}" class="diamond-modal-product__link">
                View Product Details →
              </a>
            ` : ''}
          </div>
        </div>
      `;
    });

    html += '</div>';
    return html;
  }

  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

})();
